module.exports = __webpack_public_path__ + "static/media/img-795b4590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/dug-logo.png
// module id = 5283
// module chunks = 39